var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehicle13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "64.000000pt",
    height: "64.000000pt",
    viewBox: "0 0 64.000000 64.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,64.000000) scale(0.100000,-0.100000)",
    fill: "current",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M424 410 c-76 -77 -142 -140 -146 -140 -5 0 -8 13 -8 28 0 47 -20 64 -70 60 -42 -3 -45 -5 -47 -33 -3 -28 -2 -28 7 -7 12 28 30 20 30 -13 0 -22 -2 -23 -29 -14 -15 6 -57 9 -92 7 l-64 -3 -3 -52 -3 -53 71 0 c45 0 69 -4 65 -10 -4 -6 13 -10 44 -10 l49 0 166 168 166 167 0 -112 c0 -87 -3 -113 -13 -113 -22 0 -57 -44 -57 -72 0 -42 32 -72 75 -72 42 0 75 30 75 69 0 27 -36 75 -57 75 -13 0 -14 19 -12 130 2 71 1 132 -2 134 -3 3 -68 -57 -145 -134z m-171 -103 c11 -34 6 -41 -28 -33 -20 5 -25 13 -25 37 0 26 3 30 22 27 13 -2 25 -14 31 -31z m-175 -44 c-10 -2 -26 -2 -35 0 -10 3 -2 5 17 5 19 0 27 -2 18 -5z m0 -30 c-10 -2 -26 -2 -35 0 -10 3 -2 5 17 5 19 0 27 -2 18 -5z m433 -20 c-8 -15 -10 -15 -11 -2 0 17 10 32 18 25 2 -3 -1 -13 -7 -23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 318 c-8 -4 4 -8 30 -8 23 0 42 2 42 4 0 8 -60 12 -72 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 145 c-4 -8 -4 -22 0 -30 4 -13 35 -15 185 -15 156 0 180 2 185 16 15 39 -9 44 -191 44 -145 0 -175 -2 -179 -15z m34 -16 c-2 -6 -8 -10 -13 -10 -5 0 -11 4 -13 10 -2 6 4 11 13 11 9 0 15 -5 13 -11z m320 0 c-2 -6 -8 -10 -13 -10 -5 0 -11 4 -13 10 -2 6 4 11 13 11 9 0 15 -5 13 -11z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicle13);
export default __webpack_public_path__ + "static/media/vehicle13.0090ab8f1c499b60df436da8a64f8937.svg";
export { ForwardRef as ReactComponent };